import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@icon/close.svg'


const _hoisted_1 = { class: "to-do__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToDoView = _resolveComponent("ToDoView")!
  const _component_ToDoAdd = _resolveComponent("ToDoAdd")!
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ToDoView, {
      selectedToDoInList: _ctx.selectedToDoInList,
      onAddToDo: _ctx.onShowAddToDo,
      onOnHideToDoWidget: _ctx.onHideToDoWidget
    }, null, 8, ["selectedToDoInList", "onAddToDo", "onOnHideToDoWidget"]),
    (_ctx.addToDo)
      ? (_openBlock(), _createBlock(_component_ToDoAdd, {
          key: 0,
          id: "to-do-add",
          className: "to-do__edit",
          onOnCancel: _ctx.onCloseAddAddToDo,
          onOnCloseWidget: _ctx.onHideToDoWidget
        }, null, 8, ["onOnCancel", "onOnCloseWidget"]))
      : _createCommentVNode("", true),
    (_ctx.showCloseButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "to-do-widget__close",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onHideToDoWidget && _ctx.onHideToDoWidget(...args)), ["prevent"]))
        }, [
          _createVNode(_component_icon, {
            data: _imports_0,
            fill: false,
            width: "var(--icon-24)",
            height: "var(--icon-24)"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}